import { takeEvery, takeLatest } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { createBinderAndUpload } from './createBinderAndUpload';
import { getProjectDetails } from './getProjectDetails';
import { setActiveLayer } from './setActiveLayer';
import { uploadToPromoMats } from './uploadToPromoMats';

export default [
  takeEvery(ActionTypes.GET_PROJECT_DETAILS, getProjectDetails),
  takeEvery(ActionTypes.SET_ACTIVE_LAYER, setActiveLayer),
  takeLatest(ActionTypes.UPLOAD_TO_PROMOMATS, uploadToPromoMats),
  takeLatest(ActionTypes.CREATE_BINDER_AND_UPLOAD, createBinderAndUpload),
];
